import { render, staticRenderFns } from "./AdministrativeCentersFilter.vue?vue&type=template&id=ede5a662&scoped=true"
import script from "./AdministrativeCentersFilter.vue?vue&type=script&lang=js"
export * from "./AdministrativeCentersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede5a662",
  null
  
)

export default component.exports